import React, { useCallback, useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import ContractEditorLegacy from "./ContractEditorLegacy";
import { ContractWorkspace } from "../components/contract/ContractWorkspace";

/** CRM 客户详情「建筑施工合同 · 编辑」入口: 新模板 → 工作区; 旧 master 模板草稿 / 已签合同 → 旧编辑器 (只读兼容)。 */
export default function ContractEditor(props) {
  const { leadId, api, zh } = props;
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  const load = useCallback(async (silent) => {
    try {
      const { data: d } = await api.get(`/crm/leads/${leadId}/contract/workspace`);
      setData(d); setErr(null);
    } catch (e) {
      if (!silent) setErr(e?.detailText || (zh ? "加载合同失败" : "Load failed"));
    }
  }, [api, leadId, zh]);
  useEffect(() => { load(); }, [load]);
  if (err) {
    return (
      <div className="fixed inset-0 z-[80] bg-slate-900/40 backdrop-blur-sm flex items-center justify-center" data-testid="contract-editor-error">
        <div className="bg-white rounded-2xl p-6 max-w-sm text-center shadow-2xl">
          <p className="text-sm text-red-600" data-testid="contract-editor-error-text">{err}</p>
          <button data-testid="contract-editor-error-close" onClick={props.onClose} className="mt-4 text-[12px] px-3 py-1.5 rounded-lg border border-slate-200 hover:bg-slate-50">{zh ? "关闭" : "Close"}</button>
        </div>
      </div>
    );
  }
  if (!data) {
    return <div className="fixed inset-0 z-[80] bg-slate-900/40 backdrop-blur-sm flex items-center justify-center text-white" data-testid="contract-editor-loading"><Loader2 className="h-6 w-6 animate-spin mr-2" />{zh ? "加载合同工作区…" : "Loading…"}</div>;
  }
  if (data.legacy) return <ContractEditorLegacy {...props} />;
  return <ContractWorkspace {...props} data={data} reload={load} />;
}
